/* Solara gift card page (sections/solara-gift-card.liquid).
   Amount picker -> the form's hidden variant id, the card, the price and the "covers" line.
   "Send it to them / to me" drives Shopify's recipient checkbox (recipient-form.js enables or clears the fields).
   "Right away / Pick a date" shows the Send on date (today up to 90 days ahead; empty = Shopify sends it straight away). */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function json(root, sel, fallback) { try { return JSON.parse(root.querySelector(sel).textContent); } catch (e) { return fallback; } }

  function init(root) {
    if (root.dataset.sgcReady) return;
    root.dataset.sgcReady = '1';
    var sid = root.dataset.sectionId;
    var variants = json(root, '[data-sgc-variants]', []);
    var text = json(root, '[data-sgc-text]', {});
    var form = root.querySelector('form');
    var pf = root.querySelector('product-form');
    var idInput = form.querySelector('input[name="id"]');
    var rf = root.querySelector('recipient-form');
    var cb = root.querySelector('#Recipient-checkbox-' + sid);
    var email = root.querySelector('#Recipient-email-' + sid);
    var msg = root.querySelector('#Recipient-message-' + sid);
    var date = root.querySelector('#Recipient-send-on-' + sid);
    var fields = root.querySelector('[data-sgc-fields]');
    var meHint = root.querySelector('[data-sgc-me-hint]');
    var dateBox = root.querySelector('[data-sgc-date]');
    var count = root.querySelector('[data-sgc-count]');
    var btn = root.querySelector('.sgc-atc');
    var priceEl = root.querySelector('[data-sgc-price]');
    var note = root.querySelector('.sgc-am__note');
    var covers = root.querySelector('[data-sgc-covers]');
    var fx = root.querySelector('[data-sgc-fx]');
    var card = root.querySelector('.sgc-card');

    // ---- amount ----
    function setVariant(id, push) {
      var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      idInput.value = v.id;
      root.querySelectorAll('.sgc-am__opt').forEach(function (o) {
        var r = o.querySelector('input');
        o.classList.toggle('is-on', r.value === String(v.id));
      });
      root.querySelectorAll('[data-sgc-amt]').forEach(function (e) { e.textContent = v.title; });
      if (card) card.setAttribute('aria-label', card.getAttribute('aria-label').replace(/, [^,]*$/, ', ' + v.title));
      if (priceEl) priceEl.textContent = v.price;
      if (note && covers) {
        note.hidden = !v.hint;
        if (v.hint) covers.innerHTML = esc(text.covers || '{amount} covers {what}').replace('{amount}', '<b>' + esc(v.title) + '</b>').replace('{what}', esc(v.hint));
      }
      if (fx && text.fx) fx.textContent = text.fx.replace('{value}', v.title).replace('{price}', v.price);
      if (btn) btn.disabled = !v.available;
      if (rf) { rf.dataset.productVariantId = String(v.id); rf.currentProductVariantId = String(v.id); }
      if (push && window.history && history.replaceState) {
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      }
    }
    root.querySelectorAll('.sgc-am__opt input').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) setVariant(r.value, true); });
    });

    // ---- segmented controls ----
    function seg(group, value, attr) {
      group.querySelectorAll('button').forEach(function (b) {
        var on = b.getAttribute(attr) === value;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
    var toGroup = root.querySelector('[data-sgc-to]');
    var whenGroup = root.querySelector('[data-sgc-when]');
    var mode = { to: 'them', when: 'now' };

    function clearFieldError(key) {
      var box = root.querySelector('#RecipientForm-' + key + '-error-' + sid);
      if (box) { box.classList.add('hidden'); var t = box.querySelector('.error-message'); if (t) t.textContent = ''; }
      var input = { email: email, send_on: date }[key];
      if (input) { input.removeAttribute('aria-invalid'); input.classList.remove('is-bad'); }
    }
    function fieldError(key, message, input) {
      var box = root.querySelector('#RecipientForm-' + key + '-error-' + sid);
      if (box) { box.querySelector('.error-message').textContent = message; box.classList.remove('hidden'); }
      if (input) { input.setAttribute('aria-invalid', 'true'); input.classList.add('is-bad'); if (box) input.setAttribute('aria-describedby', box.id); }
    }

    var nameInput = root.querySelector('#Recipient-name-' + sid);
    var stash = null; // what they typed before switching to "Send it to me" (recipient-form.js empties the fields)
    function setTo(to) {
      if (to === 'me' && mode.to === 'them') stash = { name: nameInput.value, email: email.value, msg: msg.value, date: date.value };
      mode.to = to;
      seg(toGroup, to, 'data-to');
      cb.checked = to === 'them';
      cb.dispatchEvent(new Event('change', { bubbles: true }));
      if (to === 'them' && stash) {
        nameInput.value = stash.name; email.value = stash.email; msg.value = stash.msg; date.value = mode.when === 'date' ? stash.date : '';
        stash = null;
      }
      fields.hidden = to !== 'them';
      meHint.hidden = to === 'them';
      if (to === 'them') setWhen(mode.when, false);
      clearFieldError('email'); clearFieldError('send_on');
      if (count) count.textContent = msg.value.length;
    }
    function setWhen(when, focus) {
      mode.when = when;
      seg(whenGroup, when, 'data-when');
      dateBox.hidden = when !== 'date';
      if (when === 'now') { date.value = ''; clearFieldError('send_on'); return; }
      var today = new Date(), max = new Date();
      max.setDate(max.getDate() + 90);
      date.min = ymd(today);
      date.max = ymd(max);
      if (focus) {
        date.focus({ preventScroll: true });
        try { if (date.showPicker) date.showPicker(); } catch (e) {}
      }
    }
    toGroup.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) setTo(b.dataset.to); });
    whenGroup.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) setWhen(b.dataset.when, true); });
    [toGroup, whenGroup].forEach(function (g) {
      g.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var bs = [].slice.call(g.querySelectorAll('button')), i = bs.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        var n = bs[(i + (e.key === 'ArrowRight' ? 1 : bs.length - 1)) % bs.length];
        n.focus(); n.click();
      });
    });

    msg.addEventListener('input', function () { if (count) count.textContent = msg.value.length; });
    email.addEventListener('input', function () { clearFieldError('email'); });
    date.addEventListener('change', function () { clearFieldError('send_on'); });

    // ---- check before the theme's product form sends it (capture phase runs first) ----
    pf.addEventListener('submit', function (e) {
      if (mode.to !== 'them') return;
      var bad = null;
      var v = (email.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { fieldError('email', text.errEmail, email); bad = bad || email; }
      if (mode.when === 'date') {
        var d = date.value;
        if (!d || (date.min && d < date.min) || (date.max && d > date.max)) { fieldError('send_on', text.errDate, date); bad = bad || date; }
      }
      if (bad) {
        e.preventDefault(); e.stopImmediatePropagation();
        bad.focus();
        bad.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }, true);

    // ---- after a successful add, recipient-form.js empties the fields and unticks the box: put our controls back ----
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (!ev || ev.source !== 'product-form' || String(ev.productVariantId) !== String(idInput.value)) return;
        setTimeout(function () { stash = null; mode.to = 'them'; setWhen('now', false); setTo('them'); }, 0);
      });
    }

    // initial state (the form may come back filled after a page reload)
    if (date.value) setWhen('date', false);
    setTo('them');
    if (count) count.textContent = msg.value.length;
  }

  function boot() { document.querySelectorAll('[data-sgc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
